export const getNewNotificationNum = (notifications) => {
    if (!notifications) return 0;
    return notifications.filter(n => !n.checked).length;
}